"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _sale = require("../api/sale.store");
var _disclaimers = _interopRequireDefault(require("../api/disclaimers.store"));
var _login = _interopRequireDefault(require("@tajawal/ct-web-account-sdk/lib/stores/login.store"));
var _country = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/country.store"));
var _travellerList = _interopRequireDefault(require("@tajawal/ct-web-account-sdk/lib/stores/traveller-list.store"));
var _fareFamilies = _interopRequireDefault(require("../fare-families.store"));
var _addons = require("../../factories/addons.factory");
var _contactPayload = _interopRequireDefault(require("../../factories/contact-payload.factory"));
var _savedTraveller = _interopRequireDefault(require("../../factories/saved-traveller.factory"));
var _fareFamilies2 = _interopRequireDefault(require("../../services/fare-families.service"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _pax = require("../../utils/pax.utils");
var _traveller = require("../../utils/traveller.utils");
var _cartProduct = require("../../utils/cart-product.utils");
var _constants = require("../../constants");
var _constants2 = require("@tajawal/web-core-sdk-v2/lib/constants");
var _addonTnc = _interopRequireDefault(require("../api/addon-tnc.store"));
var _addOns = require("../api/add-ons.store");
var _addOns2 = require("../../utils/add-ons.utils");
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FlightsPaxPageStoreV2 = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, (_class = function () {
  function FlightsPaxPageStoreV2(initialState, $env) {
    var _this = this,
      _initialState,
      _initialState2;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, FlightsPaxPageStoreV2);
    this.$env = void 0;
    this.sale = void 0;
    this.login = void 0;
    this.addOns = void 0;
    this.country = void 0;
    this.addOnTnC = void 0;
    this.disclaimers = void 0;
    this.savedTravellers = void 0;
    this.fareFamilies = void 0;
    (0, _initializerDefineProperty2.default)(this, "travellersState", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "contactState", _descriptor2, this);
    this.isAddOnLoading = (0, _mobxUtils.computedFn)(function (actionType) {
      return _this.sale.isLoading(actionType);
    });
    this.addonCart = (0, _mobxUtils.computedFn)(function (code) {
      return (0, _find2.default)(_this.sale.addonListInCart, (0, _cartProduct.isAddOnApplied)(code));
    });
    this.getAddonsList = (0, _mobxUtils.computedFn)(function (page, uiType) {
      if (uiType) {
        var currentAddons = page === _constants2.APP_PAGES.FLIGHTS_EXTRAS ? _this.extrasAddOns : _this.paxAddOns;
        return (0, _addOns2.getUIFilteredAddons)(currentAddons, uiType);
      }
      return page === _constants2.APP_PAGES.FLIGHTS_EXTRAS ? _this.extrasAddOns : _this.paxAddOns;
    });
    this.getTravellerState = (0, _mobxUtils.computedFn)(function (id) {
      return (0, _find2.default)(_this.travellersState, {
        id: id
      });
    });
    this.getTravellerIndex = (0, _mobxUtils.computedFn)(function (id) {
      return (0, _findIndex2.default)(_this.travellersState, {
        id: id
      });
    });
    this.$env = $env;
    this.updateInitialState(initialState);
    this.sale = new _sale.SaleStore(initialState.sale, $env);
    this.login = new _login.default(initialState.login, $env);
    this.country = new _country.default(initialState.currency);
    this.addOns = new _addOns.AddOnsStore((_initialState = initialState) === null || _initialState === void 0 ? void 0 : _initialState.addOns, $env);
    this.addOnTnC = new _addonTnc.default((_initialState2 = initialState) === null || _initialState2 === void 0 ? void 0 : _initialState2.addOnTnC, $env);
    this.disclaimers = new _disclaimers.default(initialState.disclaimers, $env);
    this.savedTravellers = new _travellerList.default(initialState.savedTravellers);
    this.fareFamilies = new _fareFamilies.default({}, $env);
    (0, _mobx.autorun)(function () {
      if (_this.isMetaFareFamiliesAvailable) {
        _this.fareFamilies.syncDataFromPax(_this.itinerary, _this.brandedFaresMap, _this.flightProduct.fareFamilyOptions, _this.flightProduct.searchRequest);
      }
    });
  }
  (0, _createClass2.default)(FlightsPaxPageStoreV2, [{
    key: "flightProduct",
    get: function get() {
      return this.sale.flightProduct;
    }
  }, {
    key: "itinerary",
    get: function get() {
      return this.flightProduct.itinerary;
    }
  }, {
    key: "resourceCodes",
    get: function get() {
      return (0, _get2.default)(this.flightProduct, 'resourceCodes', []);
    }
  }, {
    key: "amenitiesCodes",
    get: function get() {
      return (0, _get2.default)(this.itinerary, 'amenitiesCodes', []);
    }
  }, {
    key: "travellersPayload",
    get: function get() {
      var sortedTravellers = (0, _sortBy2.default)(this.travellersState, [function (t) {
        return t.isInfant;
      }]);
      return (0, _traveller.getTravellersPayloadFromState)(sortedTravellers);
    }
  }, {
    key: "contactPayload",
    get: function get() {
      return (0, _contactPayload.default)(this.contactState);
    }
  }, {
    key: "ssrPayload",
    get: function get() {
      return this.sale.isMultiPNR ? (0, _pax.getMultiSsrPayloadFromState)(this.travellersState) : (0, _pax.getSsrPayloadFromState)(this.travellersState);
    }
  }, {
    key: "reservationPayload",
    get: function get() {
      return {
        saleId: this.sale.id,
        cartId: this.sale.flightCartId,
        traveller: this.travellersPayload,
        contact: this.contactPayload,
        ssr: this.ssrPayload
      };
    }
  }, {
    key: "refundInfoPayload",
    get: function get() {
      return {
        itineraryId: this.itinerary.id,
        travellers: this.flightProduct.searchRequest.pax,
        chunkId: null
      };
    }
  }, {
    key: "language",
    get: function get() {
      return this.$env.config.language;
    }
  }, {
    key: "frequentFlyerList",
    get: function get() {
      return (0, _pax.getAvailableFrequentFlyers)(this.flightProduct.carriers, this.language);
    }
  }, {
    key: "savedTravellerList",
    get: function get() {
      var _this2 = this;
      return (0, _map2.default)(this.savedTravellers.data, function (traveller) {
        return (0, _savedTraveller.default)({
          traveller: traveller,
          carriers: _this2.flightProduct.carriers,
          flightDate: _this2.flightProduct.lastDepartureDate
        });
      });
    }
  }, {
    key: "savedTravellersMap",
    get: function get() {
      return (0, _groupBy2.default)(this.savedTravellerList, 'type');
    }
  }, {
    key: "isMetaFareFamiliesAvailable",
    get: function get() {
      return (0, _size2.default)(this.sale.flightProduct.fareFamilyOptions) > 1 || this.flightProduct.itinerary.hasFareFamilies;
    }
  }, {
    key: "isPricingLoading",
    get: function get() {
      return this.sale.isLoading(_constants.ACTION_TYPES.CREATE_SALE);
    }
  }, {
    key: "isPricingFetched",
    get: function get() {
      return this.sale.isFetched(_constants.ACTION_TYPES.CREATE_SALE);
    }
  }, {
    key: "isV3Reservation",
    get: function get() {
      return this.flightProduct.vendor === _constants.VENDORS.TPT;
    }
  }, {
    key: "isSaleLoading",
    get: function get() {
      return this.sale.isLoading(_constants.ACTION_TYPES.FETCH_SALE);
    }
  }, {
    key: "isAnyAddOnLoading",
    get: function get() {
      var _this3 = this;
      return (0, _some2.default)(this.availableAddOns, function (addOn) {
        return _this3.sale.isAddonLoading(addOn.id);
      });
    }
  }, {
    key: "isSaleFetched",
    get: function get() {
      return this.sale.isFetched(_constants.ACTION_TYPES.FETCH_SALE);
    }
  }, {
    key: "isSaleLoaded",
    get: function get() {
      return this.isSaleFetched || this.isPricingFetched;
    }
  }, {
    key: "isSaleUpdated",
    get: function get() {
      return this.sale.isFetched(_constants.ACTION_TYPES.UPDATE_SALE);
    }
  }, {
    key: "isSsrUpdated",
    get: function get() {
      return this.sale.isFetched(_constants.ACTION_TYPES.UPDATE_FLIGHT_SSR);
    }
  }, {
    key: "isSsrUpdating",
    get: function get() {
      return this.sale.isLoading(_constants.ACTION_TYPES.UPDATE_FLIGHT_SSR);
    }
  }, {
    key: "hasSsrUpdateError",
    get: function get() {
      return this.sale.hasError(_constants.ACTION_TYPES.UPDATE_FLIGHT_SSR);
    }
  }, {
    key: "isSeatReserved",
    get: function get() {
      return this.flightProduct.isSeatReserved;
    }
  }, {
    key: "availableAddOns",
    get: function get() {
      var _this$addOns,
        _this4 = this;
      return (0, _map2.default)((_this$addOns = this.addOns) === null || _this$addOns === void 0 ? void 0 : _this$addOns.addons, function (addOn) {
        return (0, _addons.addOnFactory)(addOn, _this4.addonCart(addOn === null || addOn === void 0 ? void 0 : addOn.packageId), _this4.$env.currency, _this4.language);
      });
    }
  }, {
    key: "addOnsMap",
    get: function get() {
      return (0, _keyBy2.default)(this.availableAddOns, 'accessKey');
    }
  }, {
    key: "paxAddOns",
    get: function get() {
      return (0, _filter2.default)(this.availableAddOns, function (addOn) {
        return addOn.placement === _constants.ADDON_PLACEMENT.TRAVELLERS;
      });
    }
  }, {
    key: "extrasAddOns",
    get: function get() {
      return (0, _filter2.default)(this.availableAddOns, function (addOn) {
        return addOn.placement === _constants.ADDON_PLACEMENT.ADDONS;
      });
    }
  }, {
    key: "isAnyExtraAddOnAdded",
    get: function get() {
      return (0, _some2.default)(this.extrasAddOns, function (addOn) {
        return addOn.isAddOnApplied;
      });
    }
  }, {
    key: "searchUrl",
    get: function get() {
      return (0, _client.replaceParams)(_constants2.APP_ROUTES.FLIGHTS_RESULTS, {
        language: this.language,
        query: this.flightProduct.query
      });
    }
  }, {
    key: "paxUrl",
    get: function get() {
      return (0, _client.replaceParams)(_constants2.APP_ROUTES.FLIGHTS_PAX, {
        language: this.language,
        saleId: this.sale.id
      });
    }
  }, {
    key: "paymentUrl",
    get: function get() {
      return (0, _client.replaceParams)(_constants2.APP_ROUTES.FLIGHTS_PAYMENT, {
        language: this.language,
        saleId: this.sale.id
      });
    }
  }, {
    key: "countryList",
    get: function get() {
      var _this5 = this;
      var formatCountry = function formatCountry(country) {
        var label = (0, _find2.default)(country.labelData, function (item) {
          return item.Locale.includes(_this5.language);
        }) || {};
        return _objectSpread(_objectSpread({}, country), {}, {
          label: label.Value
        });
      };
      return (0, _map2.default)(this.country.countryList, formatCountry);
    }
  }, {
    key: "contact",
    get: function get() {
      var contact = this.sale.contact;
      var countryId = this.country.getCountryCodeByDialCode(contact.dialCode);
      return _objectSpread(_objectSpread({}, this.sale.contact), {}, {
        countryId: countryId
      });
    }
  }, {
    key: "brandedFaresMap",
    get: function get() {
      var _this$flightProduct$b, _this$flightProduct;
      return (_this$flightProduct$b = (_this$flightProduct = this.flightProduct) === null || _this$flightProduct === void 0 ? void 0 : _this$flightProduct.brandedFares) !== null && _this$flightProduct$b !== void 0 ? _this$flightProduct$b : {};
    }
  }, {
    key: "$fareFamilies",
    get: function get() {
      return (0, _fareFamilies2.default)({
        fareFamilies: {},
        brandedFares: this.brandedFaresMap
      });
    }
  }, {
    key: "initializeTravellersState",
    value: function initializeTravellersState() {
      this.travellersState = this.flightProduct.travellers;
    }
  }, {
    key: "initializeContactState",
    value: function initializeContactState() {
      this.contactState = this.contact;
    }
  }, {
    key: "setTravellersState",
    value: function setTravellersState(nextState) {
      if ((0, _traveller.isValidTravellersState)(nextState)) {
        this.travellersState = nextState;
      }
    }
  }, {
    key: "setContactState",
    value: function setContactState(nextState) {
      if ((0, _pax.isValidContactState)(nextState)) {
        this.contactState = nextState;
      }
    }
  }, {
    key: "updateTravellerState",
    value: function updateTravellerState(_ref) {
      var id = _ref.id,
        payload = _ref.payload;
      var travellerIndex = this.getTravellerIndex(id);
      if (travellerIndex !== -1) {
        this.travellersState[travellerIndex] = (0, _traveller.updateTravellerState)(this.travellersState[travellerIndex], payload);
      }
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      if (initialState === void 0) {
        initialState = {};
      }
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }]);
  return FlightsPaxPageStoreV2;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "travellersState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contactState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerary", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resourceCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resourceCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "amenitiesCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amenitiesCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "travellersPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "travellersPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contactPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contactPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "ssrPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "ssrPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reservationPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reservationPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "refundInfoPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "refundInfoPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "language", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "language"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "frequentFlyerList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "frequentFlyerList"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "savedTravellerList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedTravellerList"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "savedTravellersMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedTravellersMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isMetaFareFamiliesAvailable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMetaFareFamiliesAvailable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPricingLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPricingLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPricingFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPricingFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isV3Reservation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isV3Reservation"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isAnyAddOnLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnyAddOnLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleLoaded"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSaleUpdated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSaleUpdated"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSsrUpdated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSsrUpdated"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSsrUpdating", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSsrUpdating"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasSsrUpdateError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSsrUpdateError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isSeatReserved", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSeatReserved"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableAddOns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAddOns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "addOnsMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "addOnsMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paxAddOns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paxAddOns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "extrasAddOns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "extrasAddOns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isAnyExtraAddOnAdded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnyExtraAddOnAdded"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paxUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paxUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "countryList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "countryList"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "brandedFaresMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "brandedFaresMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "$fareFamilies", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "$fareFamilies"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeTravellersState", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initializeTravellersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeContactState", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "initializeContactState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setTravellersState", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "setTravellersState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setContactState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "setContactState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateTravellerState", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "updateTravellerState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class));